import {TFunction} from 'react-i18next';
import Excel from 'exceljs';
import {
	renderHeaderXL,
	createZIPXL,
	renderPhaseDateXL,
	renderDateXL,
	renderArrayXL,
	renderHTMLStringXL,
} from './ExcelExportCommon';
import {RegulatoryDocument} from 'types';

interface IExcel {
	(
		entityListiRegDocs: any[],
		columnNames: string[],
		t: TFunction,
	): Promise<void>;
}

export const handleClickVoProPage: IExcel = async (
	entityListiRegDocs,
	columnNames,
	t,
) => {
	const arrRegDocFilt = entityListiRegDocs;

	const strPageName = t('RegulatoryDocuments', {
		ns: 'appShell/sidenavigation',
		keyPrefix: 'SideNavigation',
	});

	const arrColWidth = [
		60,
		40,
		...new Array(3).fill(25),
		40,
		40,
		...new Array(10).fill(25),
	];
	const workbook = new Excel.Workbook();
	const sheet = workbook.addWorksheet('TRACE_' + strPageName);
	renderHeaderXL(workbook, sheet, arrColWidth, strPageName, t);

	let intRowCount = 4;
	let row = sheet.getRow(intRowCount);
	row.font = {
		bold: true,
		name: 'Porsche Next TT',
		size: 10,
		color: {argb: 'FFFFFFFF'},
	};
	sheet.addTable({
		name: 'tableVoPro',
		ref: 'B' + String(intRowCount),
		style: {
			showRowStripes: true,
		},
		columns: columnNames.map(x => {
			return {name: x, filterButton: true};
		}),
		rows: [],
	});

	intRowCount++;
	const table = sheet.getTable('tableVoPro');

	arrRegDocFilt.forEach((iRegDoc: RegulatoryDocument) => {
		row = sheet.getRow(intRowCount);
		row.alignment = {wrapText: true, vertical: 'top'};
		row.getCell('I').alignment = {horizontal: 'left'};
		row.getCell('C').style.font = {
			underline: true,
			bold: false,
			color: {argb: '00B0F0'},
		};

		table.addRow([
			renderHTMLStringXL('', iRegDoc.summary),
			{
				text: `${iRegDoc.regulation?.regulationNumber ?? ''} | ${iRegDoc.name}`,
				hyperlink: `${window.location.origin}/regulatoryDocuments/${iRegDoc.id}`,
			},
			renderDateXL(iRegDoc.workflow?.clearingTimestamp),
			renderArrayXL(iRegDoc.contactPersons),
			renderArrayXL(iRegDoc.markets),
			renderArrayXL(iRegDoc.mainKeywords),
			renderArrayXL(iRegDoc.keywords),
			t(iRegDoc.status, {
				ns: 'common/enums',
				keyPrefix: 'RegulatoryDocumentStatus',
			}),
			renderDateXL(iRegDoc.dateEffective),
			renderDateXL(iRegDoc.dateNewTypes),
			renderDateXL(iRegDoc.dateNewRegistration),
			renderDateXL(iRegDoc.comprehensive),
			iRegDoc.modelYear ?? '',
			renderPhaseDateXL(iRegDoc.phaseIn),
			renderPhaseDateXL(iRegDoc.phaseOut),
			t(iRegDoc.workflow.status, {
				ns: 'common/enums',
				keyPrefix: 'WorkflowStatus',
			}),
		]);

		intRowCount++;
	});

	table.commit();
	const strZipName = strPageName;
	await createZIPXL(workbook, strZipName, t);
};
